import script from "./sf-pagination-ds.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-pagination-ds.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__